import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as constants from "../const";
import { showModalAction, getFRADetailsAction } from "../actions/index";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/src/SuperResponsiveTableStyle.css";
import moment from "moment";
import './manuallyUpdate.css';
import printIcon from '../../../src/assets/images/print.png';

class FRAReportWorkday extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: false
    };
  }
  showModal(modalObj) {
    var workday = this.props.workday;
 
    var workdayDate = moment(modalObj.workdayDate, 'MM/DD/YYYY')
    workdayDate = workdayDate.format('YYYYMMDD');
    let role = this.props.role;
    let url = constants.actionUrls.FRA_DETAILS;
    //'/fradetails/:role/:workdayId/:certifyStatus/:empId/:workdayDate/:dutyActivityStatus/:isPayDetail',
    url = url + "/" + role + "/" + modalObj.workdayId + "/" + modalObj.certifyStatus
    + "/" + modalObj.empId + "/" + workdayDate + "/" + modalObj.dutyActivityStatus;
    if(workday.isPayDetail){
        url = url+ "/" + workday.isPayDetail + "/" + workday.RestBreakNo
    }
    this.props.getFRADetail(url);

    this.props.onShowModal(modalObj.modalName);
  }
  
  rendeStatusForHosLog(modalObj) {
    var workday = this.props.workday,
        certifyTxt = workday.dutyActivityStatus == 'N' ? 'OFF' : 
                'Not Certified'
    var colorCode = function(){
        if(workday.dutyActivityStatus == 'N'){
            return constants.COLORS.Black;
        } else if(workday.wdy_certify_status == constants.UNCERTIFIED){
            return constants.COLORS.Green;
        }
    }
    return (
      <div>
          <a className={"pointer  " + (workday.dutyActivityStatus == "N" ? "underline" : "")} style={{"color": colorCode()}} 
            onClick={() =>this.showModal(modalObj)}>
              {
                workday.wdy_certify_status == constants.UNCERTIFIED ? certifyTxt 
                  : workday.IsAmendment == '1' ? 'Ammendment-' + workday.AmendmentId : workday.created_by == 'system' ? 'Certified-s' : 'Certified'
              }
          </a>
      </div>
    );
}
  render() {
      if (this.props.workday) {
      let workday = this.props.workday;
      let totHos = workday.wdy_working_time_hos_adjust && workday.wdy_working_time_hos_adjust.toLowerCase().lastIndexOf('m') <= 0? workday.wdy_working_time_hos_adjust.trim().toUpperCase() + 'M':workday.wdy_working_time_hos_adjust;
        let adjustedHOS = (workday.isPayDetail == '0' && (workday.wdy_certify_status.trim() === 'C'))
        ? totHos: "";   
        
          let certifiedDate = (workday.isPayDetail == '0' && (workday.wdy_certify_status.trim() === 'C'))
              ? workday.wdy_certify_date : "";

      let full_name = workday.emp_full_name.split(" "),
        first_name = full_name[full_name.length-1],
        last_name = workday.emp_full_name.replace(first_name,'');
      let modalObj = {
        workdayId:workday.id,
        certifyStatus:workday.wdy_certify_status,
        empId:workday.demp_display_Id,
        workdayDate:workday.wdy_date,
        modalName: constants.hosModals.Certify_Modal,
        dutyActivityStatus:workday.dutyActivityStatus
      }
     
      return (
        <tr>
          <td className="width5">
          <input type="checkbox" name="chkEmployee" id={this.props.workday.demp_display_Id +"_" + workday.wdy_date} />
          </td>
          <td data-title="Employee ID" className="text-center">
            {this.props.workday.demp_display_Id}
          </td>
          <td data-title="First Name" className="text-center"> {first_name} </td>
          <td data-title="Last Name" className="text-center"> {last_name} </td>
          <td data-title="Service Date" className="text-center"> {workday.wdy_date} </td>
          <td data-title="Type" className="text-center"> {workday.job_type} </td>
          <td data-title="Total HOS" className="text-center"> {adjustedHOS} </td>
              <td data-title="Date" className="text-center">{certifiedDate} </td>
          <td  data-title="Date" className="text-center statusLog">
          {
            this.rendeStatusForHosLog(modalObj)
          } 
          </td>
        </tr>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    workdays: state.workdays.workdays,
    pageNum: state.workdays.pageNum
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      onShowModal: showModalAction,
      getFRADetail: getFRADetailsAction
    },
    dispatch
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(
  FRAReportWorkday
);
